module.exports = __webpack_public_path__ + "static/media/heart19.5b06f6ca.svg";